<template>
    <div class="modal-content">
        <div class="modal-header p-b-0">
            <button @click="close()" type="button" class="close" aria-hidden="true">×</button>
        </div>

        <div class="modal-body p-b-0 p-t-0">
            <div class="text-center">
                <h2 class="text-center m-b-30">Ops... Aparentemente você não possui moedas suficientes em sua carteira para isso.</h2>

                <img src="/images/moedas-icons/need-coins.svg" alt="" />

                <p class="m-b-30">
                    Parece que você não possui a quantidade necessária de moedas para essa operação.
                    Para continuar, realize a compra de Moedas do WebQuarto, clicando no botão abaixo.
                </p>

                <div class="text-left m-t-30 m-b-30">
                    <a class="btn-link" href="https://ajuda.webquarto.com.br/article/132-como-funcionam-as-moedas-webquarto" target="_blank">O que são e como funcionam as Moedas do WebQuarto?</a>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-sm-6 m-b-10">
                        <button @click="close()" class="btn btn-block btn-lg w-lg btn-white waves-effect waves-light">Sair</button>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-10">
                        <a @click="trackEvent('buy_credits')" href="/comprar-moedas" class="btn btn-block btn-success btn-lg w-lg">Comprar Moedas</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        trackEvent(event) {
            window.dataLayer.push({
                'event': 'needcredits_modal-conversion',
                'event_category': 'credits-events',
                'event_label': event
            });
        },
        close() {
            this.$emit('close-modal');
        }
    },
    created() {
        window.dataLayer.push({
            'event': 'show_needcredits_modal',
            'event_category': 'credits-events',
            'event_label': location.pathname
        });
    }
}
</script>

<style lang="scss" scoped>
    img {
        width: 175px;
        margin-bottom: 45px;
    }
</style>
